module.exports = __webpack_public_path__ + "static/media/project9.efd1598f.png";